import React, { useState, useEffect } from 'react'
import { addDays, format } from 'date-fns'
import { DateRange, DayPicker } from 'react-day-picker'
import { isSameDay } from 'date-fns'
import { ko } from 'date-fns/locale'
import 'react-day-picker/dist/style.css'
import styled from 'styled-components'

const today = new Date()

export default function SelectRange({
  range,
  setRange,
  rangeDates,
  setRangeDates,
}) {
  const handleDayClick = (day, modifiers) => {
    setRangeDates([])
  }
  return (
    <Container>
      <DayPicker
        mode="range"
        selected={range}
        onSelect={setRange}
        numberOfMonths={2}
        locale={ko}
        // onDayClick={handleDayClick}
      />
    </Container>
  )
}
const Container = styled.div`
  .rdp-day_today {
    color: #00a61c;
    text-decoration: underline 2px;
  }
  .rdp-day_range_start,
  .rdp-day_range_end {
    color: white !important;
  }

  .rdp-months {
    width: 578px;
    height: 355px;
    justify-content: center !important;
    border-radius: 8px;
    border: solid 1px #e5e5e5;
    background-color: #fff;
    padding: 20px 0px;
    @media ${(props) => props.theme.mobile} {
      border: none;
    }
  }

  .rdp-multiple_months {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .rdp-head_cell {
    color: var(--global-color-mainG);
  }
  .rdp-day_selected,
  .rdp-day_selected:focus-visible,
  .rdp-day_selected:hover {
    background-color: #00a61c !important;
  }
  .rdp-button:hover:not([disabled]):not(.rdp-day_selected) {
    background-color: #eef3e4 !important;
  }
  .rdp-month {
    margin: 0;
  }
  .rdp-day_range_middle {
    background-color: #eef3e4 !important;
    color: black;
  }
  .rdp-month:first-child {
    padding: 20px 0px 20px 20px;
    margin-right: 0.5em;
  }
  .rdp-month:last-child {
    padding: 20px 20px 20px 0px;
  }

  @media ${(props) => props.theme.mobile} {
    .rdp-months {
      display: inline-block;
    }
    .rdp-month:first-child {
      border-radius: 8px;
      border: 1px solid rgb(229, 229, 229);
      background-color: rgb(255, 255, 255);
      padding: 20px;
    }
    .rdp-month:last-child {
      padding: 20px;
      margin: 0;
      margin-top: 20px;
      border-radius: 8px;
      border: 1px solid rgb(229, 229, 229);
      background-color: rgb(255, 255, 255);
    }
  }
  @media ${(props) => props.theme.tablet} {
    .rdp-months {
      /* width: 578px; */
    }
    .rdp-multiple_months {
      /* width: 578px; */
      margin: auto;
      margin-top: 15px;
    }
  }
`
